import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { isEqual } from 'lodash';
import AvatarEditor from 'react-avatar-editor';
import { Tooltip } from '@components/common';

const INITIAL_STATE = {
	showModal : false,
	settings  : {},
	scale     : 1,
};

class EditImage extends Component {
	constructor() {
		super();

		this.state = { ...INITIAL_STATE };
	}

	shouldComponentUpdate = (nextProps, { showModal, settings, scale }) => {
		const lastState = this.state;

		return (
			!isEqual(lastState.showModal, showModal)
			|| !isEqual(lastState.settings, settings)
			|| !isEqual(lastState.scale, scale)
		);
	};

	handleOnCancel = () => {
		const { settings } = this.state;

		if (settings.onCancel) settings.onCancel();

		this.reset();
	}

	reset = () => {
		this.setState({ ...INITIAL_STATE });
	}

	openModal = (settings) => {
		this.setState({
			showModal : true,
			settings,
		});
	}

	handleOnSave = () => {
		const { settings } = this.state;

		if (this.editor) {
			this.editor.getImage().toBlob((blob) => {
				this.reset();
				settings.onSave(blob, this.editor.getImage().toDataURL());
			});
		}
	}

	handleScale = (e) => {
		const scale = parseFloat(e.target.value);
		this.setState({ scale });
	}

	setEditorRef = (editor) => {
		this.editor = editor;
	}

	render() {
		const {
			showModal,
			settings,
			scale,
		} = this.state;

		return (
			<Modal
				keyboard={false}
				backdrop="static"
				show={showModal}
				onHide={this.handleOnCancel}
			>
				<Modal.Header closeButton>
					<Modal.Title>Edit Image</Modal.Title>
					<Modal.Body>
						<div className="flex flex-center flex-direction-column">
							<AvatarEditor
								ref={(editor) => this.setEditorRef(editor)}
								image={settings.imageToEdit}
								width={155}
								height={155}
								border={50}
								color={[255, 255, 255, 0.6]} // RGBA
								scale={scale}
								rotate={0}
							/>
							<div className="margin-auto width-50-p">
								<Tooltip content="zoom">
									<input
										name="scale"
										type="range"
										onChange={(e) => this.handleScale(e)}
										min="1"
										max="2"
										step="0.01"
										defaultValue="1"
									/>
								</Tooltip>
								<div className="text-center margin-top-15">
									<Button
										bsStyle="link"
										className="margin-left-10"
										onClick={this.handleOnCancel}
									>
										Cancel
									</Button>
									<Button
										bsStyle="primary"
										onClick={this.handleOnSave}
									>
										Save
									</Button>
								</div>
							</div>
						</div>
					</Modal.Body>
				</Modal.Header>
			</Modal>
		);
	}
}

export default EditImage;
